import { defineComponent as _defineComponent } from 'vue'
import CarouselArrowButton from 'JS/components/carousels/CarouselArrowButton.vue';
import FeaturedCategoriesWidgetCard from './FeaturedCategoriesWidgetCard.vue';
import { AnalyticsPromoAttrs } from 'JS/utilities/analytics';
import { FeaturedCategoriesWidgetResource } from 'JS/dxp/types/widgets';
import { nextTick, ref, watch } from 'vue';
import { useViewportWidth } from 'JS/composables/breakpoint';



export default /*#__PURE__*/_defineComponent({
  __name: 'FeaturedCategoriesPageTitle',
  props: {
    widget: null,
    pageTitle: null,
    gaDataAttributes: null,
    getClickDataAttributes: null
  },
  setup(__props: any) {

const props = __props as {
	widget: FeaturedCategoriesWidgetResource,
	pageTitle: string,
	gaDataAttributes: AnalyticsPromoAttrs,
	getClickDataAttributes: Function,
}



const showCarouselArrows = ref(false);

const viewportWidth = useViewportWidth();

function evaluateShowArrows(newWidth: number) {
	const numItems = props.widget.data?.items?.length ?? 0;

	if (numItems > 10) {
		return true;
	} else if (numItems > 9 && newWidth < 1470) {
		return true;
	} else if (numItems > 8 && newWidth < 1310) {
		return true;
	} else if (numItems > 7 && newWidth < 1170) {
		return true;
	}

	return false;
}

watch(() => viewportWidth.value, () => {
	nextTick(()=> {
		showCarouselArrows.value = evaluateShowArrows(viewportWidth.value);
	});
}, { immediate: true });


return { __sfc: true,props, showCarouselArrows, viewportWidth, evaluateShowArrows, CarouselArrowButton, FeaturedCategoriesWidgetCard }
}

})